import { CSSProperties, FC } from "react";
import { css, StyleSheet } from "aphrodite";
import DeprecatedIcon from "@src/deprecatedDesignSystem/components/DeprecatedIcon";
import { DeprecatedIconType } from "@src/deprecatedDesignSystem/deprecatedIcons";
import { deprecatedTones } from "../styles/deprecatedColors";
import Text from "@ui/text";

type Props = {
  icon?: DeprecatedIconType;
  text: string;
  type: "success" | "neutral" | "error" | "blue";
  width?: "full" | "hug";
  shouldWrap?: boolean;
  style?: CSSProperties;
  onClick?: () => void;
};

const Banner: FC<Props> = ({
  icon,
  text,
  type,
  width,
  shouldWrap = false,
  onClick,
  style,
}) => {
  let iconColor: string = deprecatedTones.green10;
  let fontColor: string = deprecatedTones.green12;
  let backgroundColor: string = deprecatedTones.green1Alpha;

  switch (type) {
    case "neutral":
      iconColor = deprecatedTones.gray8;
      fontColor = deprecatedTones.gray12;
      backgroundColor = deprecatedTones.gray4Alpha;
      break;
    case "error":
      iconColor = deprecatedTones.red9;
      fontColor = deprecatedTones.red12;
      backgroundColor = deprecatedTones.red2;
      break;
    case "blue":
      fontColor = deprecatedTones.blue11;
      iconColor = deprecatedTones.blue11;
      backgroundColor = deprecatedTones.blue2;
  }

  return (
    <div
      className={css(
        styles.container,
        width === "full" && styles.displayFlex,
        width === "hug" && styles.displayInlineFlex,
        onClick && styles.clickable,
      )}
      style={{ backgroundColor, ...style }}
      onClick={onClick}
    >
      {icon && (
        <DeprecatedIcon
          type={icon}
          color={iconColor}
          style={{ marginRight: 4 }}
        />
      )}
      <Text
        type="P2"
        fontWeight="Medium"
        color={fontColor}
        multiline={shouldWrap}
      >
        {text}
      </Text>
    </div>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: "8px 16px 8px 8px",
    borderRadius: 8,
  },
  displayFlex: {
    display: "flex",
    alignItems: "center",
  },
  displayInlineFlex: {
    display: "inline-flex",
  },
  clickable: {
    cursor: "pointer",
  },
});

export default Banner;
